import { Button, ButtonGroup } from "@mui/material";
import { gray600, primary50 } from "../../theme";

export const ButtonGroupSelect = ({
  options = [{ label: "One", value: 1 }],
  selected,
  onSelect,
  ariaLabel = "Button group",
  ...props
}) => {
  return (
    <ButtonGroup aria-label={ariaLabel} {...props}>
      {options.map(({ label, value }) => (
        <Button
          onClick={(e) => {
            onSelect?.({ value });
          }}
          sx={
            value === selected
              ? {
                  bgcolor: primary50,
                  fontWeight: 600,
                }
              : {
                  fontWeight: 500,
                  color: gray600,
                }
          }
        >
          {label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
